import { inject, Injectable } from '@angular/core';

import { AUTHENTICATION_REDIRECT, SSO_LOGIN_URL } from '../tokens/authentication-redirect.token';

@Injectable({
  providedIn: 'root',
})
export class SsoNavigationService {
  private readonly redirect = inject(AUTHENTICATION_REDIRECT);
  private readonly ssoLoginUrl = inject(SSO_LOGIN_URL);
  private redirectStarted = false;

  public redirectToSso(): void {
    if (this.redirectStarted) {
      return;
    }

    this.redirectStarted = true;

    const ssoUrl = new URL(this.ssoLoginUrl);
    const currentPath = window.location.pathname;
    if (currentPath !== '/') {
      ssoUrl.searchParams.set('target', currentPath.slice(1));
    }

    this.redirect(ssoUrl.toString());
  }
}
